import { render } from "./tcedit.vue?vue&type=template&id=44c6a00c&scoped=true"
import script from "./tcedit.vue?vue&type=script&lang=js"
export * from "./tcedit.vue?vue&type=script&lang=js"

import "./tcedit.vue?vue&type=style&index=0&id=44c6a00c&lang=scss&scoped=true"
import "./tcedit.vue?vue&type=style&index=1&id=44c6a00c&scoped=true&lang=css"

import exportComponent from "D:\\workCode\\PC\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44c6a00c"]])

export default __exports__